/**************************************************
 * Nombre:       Formulario_Productos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {useIngresarObjeto} from "../../Modulo_formularios/Hooks/useIngresarObjeto";
import Tarjeta_Variacion_Producto from "../Tarjeta/Tarjeta_Variacion_Producto";
import Formulario_Variacion_Producto from "./Formulario_Variacion_Producto";


const Formulario_Variacion = ({...props}) => {
    const {IngresarObjeto} = useIngresarObjeto({
        dato: 'variaciones',
        nombre: 'Agregar Variante',
        props: props,
        Formulario: Formulario_Variacion_Producto,
        Tarjeta: Tarjeta_Variacion_Producto
    })

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Typography sx={{fontSize: 14}}>Ingrese las variaciones</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresarObjeto/>
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Variacion